import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { Alert, Kpi, KpiGrid, Muted, PageHeader, Section } from '@/components/ui'
import { fetchAnalyticsDashboard, fetchRhKpis } from './api'

function num(v: unknown) {
  const n = typeof v === 'number' ? v : Number(v)
  return Number.isFinite(n) ? n.toLocaleString('pt-BR') : '—'
}

export function CommandCenterPage() {
  const rh = useQuery({ queryKey: ['rh', 'kpis'], queryFn: fetchRhKpis })
  const analytics = useQuery({
    queryKey: ['analytics', 'dashboard'],
    queryFn: fetchAnalyticsDashboard,
  })

  const turnover = analytics.data?.turnover_mes as Record<string, unknown> | undefined
  const enps = analytics.data?.enps as Record<string, unknown> | undefined

  return (
    <section className="hi-page">
      <PageHeader
        title="Visão executiva"
        subtitle="KPIs consolidados de RH e People Analytics. Mapas e simuladores avançados seguem no legado."
        actions={
          <>
            <Link className="btn btn-secondary" to="/app/analytics">
              Analytics
            </Link>
            <a className="btn btn-secondary" href={legacyAppUrl('#/command-center')}>
              Legado
            </a>
          </>
        }
      />

      {rh.isError ? (
        <Alert tone="danger">
          {rh.error instanceof ApiError ? rh.error.message : 'Falha ao carregar KPIs de RH.'}
        </Alert>
      ) : null}
      {analytics.isError ? (
        <Alert tone="warning">
          {analytics.error instanceof ApiError
            ? analytics.error.message
            : 'Analytics indisponível para este perfil.'}
        </Alert>
      ) : null}

      {(rh.isLoading || analytics.isLoading) && <Muted>Carregando indicadores…</Muted>}

      {rh.data && Object.keys(rh.data).length > 0 ? (
        <Section title="Headcount">
          <KpiGrid>
            <Kpi label="Ativos / total" value={num(rh.data.total)} />
            <Kpi label="Admissões no mês" value={num(rh.data.adm_mes)} />
            <Kpi label="Desligamentos" value={num(rh.data.deslig_mes)} />
            <Kpi label="Em férias" value={num(rh.data.em_ferias)} />
            <Kpi label="Afastados" value={num(rh.data.afastados)} />
            <Kpi label="Turnover %" value={num(rh.data.turnover)} />
            <Kpi label="Aval. pendentes" value={num(rh.data.aval_pend)} />
          </KpiGrid>
        </Section>
      ) : null}

      {analytics.data && Object.keys(analytics.data).length > 0 ? (
        <Section title="Clima e risco">
          <KpiGrid>
            <Kpi label="Engajamento médio" value={num(analytics.data.score_engajamento_medio)} />
            <Kpi label="Score geral" value={num(analytics.data.score_geral_medio)} />
            <Kpi label="Alertas críticos" value={num(analytics.data.alertas_criticos)} />
            <Kpi label="Turnover mês %" value={num(turnover?.taxa_turnover)} />
            <Kpi label="eNPS" value={num(enps?.eNPS)} />
          </KpiGrid>
        </Section>
      ) : null}
    </section>
  )
}
